import { useCallback, useEffect, useRef, useState } from "react"
import { getExpertiseList } from "../../services/partnerExpertService";
import { ExpertiseListModel } from "./models/ExpertiseListModel";

export const useExpertiseList = (partnerId: number, state: "open" | "closed" | "requests") => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState<ExpertiseListModel[]>([]);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const load = useCallback(async () => {
        try {
            setLoading(true);
            setList([]);
            const _result = await getExpertiseList(partnerId, state)
            if(!isMountedRef.current)
                return;
            setList(_result.results);
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [partnerId, state]);

    useEffect(() => {
        load();
    }, [load]);

    return { loading, list }
}